import { Injectable } from '@angular/core';
import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Router } from '@angular/router';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

export const AXELA_LOCKED_PATH = '/account-with-axela';

@Injectable()
export class AxelaLockedInterceptor implements HttpInterceptor
{
    constructor(private _router: Router) {
    }

    intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
        return next.handle(req).pipe(catchError((error: HttpErrorResponse) => {
            const body = error?.error;
            if (error?.status === 403 && body?.code === 'axela_locked' && body?.permission === 'login' && !this._router.url.startsWith(AXELA_LOCKED_PATH)) {
                this._router.navigateByUrl(AXELA_LOCKED_PATH, {state: {agencyName: body.agencyName, payUrl: body.payUrl, phone: body.phone}});
            }
            return throwError(() => error);
        }));
    }
}
